import { Col, Divider, Row } from 'antd';
import { IListColumn } from 'src/@types/search-params';
import TableContent from 'src/components/CTable';
import useWindowSize from 'src/hooks/useWindowSize';
import { IOverFlowOrderDetailResponse } from 'src/shared/interface/package_assigned';
import CGridView from '../CGridView';

interface InputError {
  dataFailed: IOverFlowOrderDetailResponse[];
}

function InputError({ dataFailed }: InputError) {
  const size = useWindowSize();
  const columns: IListColumn[] = [
    { name: 'STT', fieldName: 'index', width: 20, isHideSort: true },
    { name: 'SIM serial', fieldName: 'serial', isHideSort: true },
    {
      name: 'Mã gói',
      fieldName: 'mbfCode',
      isHideSort: true,
    },
    { name: 'Mã lỗi', fieldName: 'code', isHideSort: true },
    { name: 'Lý do', fieldName: 'message', isHideSort: true },
  ];

  return size.width < 1024 ? (
    <CGridView length={dataFailed?.length} totalRecord={dataFailed?.length ?? 0} columns={columns}>
      {dataFailed && dataFailed.length > 0 ? (
        dataFailed.map((item: IOverFlowOrderDetailResponse) => {
          return (
            <div key={'data-row-' + item.id}>
              <Divider className='border-t-black' />

              <Row className='mb-6  items-center' gutter={[4, 16]}>
                {columns.map((ele) => {
                  if (ele.fieldName !== 'index' && ele.fieldName !== 'action') {
                    return (
                      <>
                        <Col span={11} className={`font-bold label`}>
                          <div className='flex gap-2 items-center'>{ele.name}</div>
                        </Col>
                        <Col className='break-words text-right' span={13}>
                          {ele?.renderSpecialCard
                            ? ele?.renderSpecialCard(item, null, null, null)
                            : item[`${ele?.fieldName}`]}
                        </Col>
                      </>
                    );
                  } else if (ele.fieldName === 'action') {
                    return (
                      <Col key={'column-' + item.id + ele.fieldName} span={24}>
                        <div className='flex gap-6'>
                          {ele?.renderSpecialCard
                            ? ele?.renderSpecialCard(item, null, null, null)
                            : item[`${ele?.fieldName}`]}
                        </div>
                      </Col>
                    );
                  } else {
                    return <></>;
                  }
                })}
              </Row>
            </div>
          );
        })
      ) : (
        <p>{'Không có dữ liệu'}</p>
      )}
    </CGridView>
  ) : (
    <TableContent
      bordered
      scroll={{ x: 'max-content' }}
      locale={{ emptyText: 'Không tìm thấy kết quả' }}
      dataSource={dataFailed}
      columns={columns}
      isHidePaging={true}
    />
  );
}

export default InputError;
